import React from "react";
// ANT DESIGN COMPONENTS
import { Button } from "antd";
// FONT AWESOME LIBRARY AND ICONS
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowsRotate, faFileImport } from "@fortawesome/free-solid-svg-icons";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// REDUX
import { useDispatch, useSelector } from "react-redux";
import { updateServerRefreshTable, updateOpenModalImportServer } from "../../../redux/servers/serverSlice";
// AUTHORIZATION
import validatePermission from "../../../utils/validatePermissions";
// INTERFACES
import { RootState } from "../../../app/store";

function ServersHeader() {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */
	const dispatch = useDispatch();
	const [t] = useTranslation("global");

	// ************************************************ */
	// USE STATE VARIABLES **************************** */

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */
	const { permissions } = useSelector((state: RootState) => state.user);

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */

	// ************************************************ */
	// FUNCTIONS ************************************** */
	const handleOpenModalImportServer = () => {
		dispatch(updateOpenModalImportServer(true));
	};

	const handleReloadPage = () => {
		dispatch(updateServerRefreshTable(true));
		setTimeout(() => {
			dispatch(updateServerRefreshTable(false));
		}, 1000);
	};

	return (
		<div className='generalStyles__pageHeader'>
			{validatePermission("servers-view", permissions) && (
				<div className='generalStyles__mlFix mt-1'>
					<Button
						className='buttonStyle__8'
						icon={<FontAwesomeIcon icon={faArrowsRotate} className='generalStyles__mrFix' />}
						onClick={() => {
							handleReloadPage();
						}}
					>
						{t("edgeManagement.servers.refreshTable")}
					</Button>
				</div>
			)}
			{validatePermission("servers-import", permissions) && (
				<div className='generalStyles__mlFix mt-1'>
					<Button
						type='primary'
						icon={<FontAwesomeIcon icon={faFileImport} className='generalStyles__mrFix' />}
						onClick={handleOpenModalImportServer}
					>
						{t("edgeManagement.servers.importServer")}
					</Button>
				</div>
			)}
		</div>
	);
}

export default ServersHeader;
